/* eslint-disable */
import { produce } from "immer";
import {
  SCHEMA_DOCUMENT_FETCH_FAILURE,
  SCHEMA_DOCUMENT_FETCH_SUCCESS,
  SCHEMA_DOCUMENT_FETCH_START,
} from "../actions/types";

const SchemeDocumentReducer = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case SCHEMA_DOCUMENT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case SCHEMA_DOCUMENT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case SCHEMA_DOCUMENT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default SchemeDocumentReducer;
